import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowDown2, Translate } from "iconsax-react";
import { Dropdown, DropdownItem } from "@/shared/ui";
import { LANGUAGE_OPTIONS } from "../consts";
import type { LanguageOption } from "../consts";

export default function LanguageRow() {
  const { t, i18n } = useTranslation("Sidebar");
  const [open, setOpen] = useState(false);
  const currentLanguage = LANGUAGE_OPTIONS.find((lng) => lng.value === i18n.language) ?? LANGUAGE_OPTIONS[0];

  function handleSelect(value: LanguageOption["value"]) {
    i18n.changeLanguage(value);
    setOpen(false);
  }

  return (
    <div className="flex items-center gap-2 py-2 h-[44px]">
      <div className="flex items-center justify-center">
        <Translate size={18} color="currentColor" className="shrink-0 content-base-primary" />
      </div>
      <div className="flex items-center justify-between flex-1">
        <span className="text-label-sm content-base-primary whitespace-nowrap">{t("language")}</span>
        <Dropdown open={open} onClose={() => setOpen(false)} align="right" width="w-36" usePortal={false}>
          <button
            type="button"
            aria-expanded={open}
            onClick={(e) => {
              e.stopPropagation();
              setOpen((prev) => !prev);
            }}
            className="flex items-center gap-1.5 cursor-pointer">
            <img src={currentLanguage.flag} alt="" className="w-4 h-4 radius-full object-cover shrink-0" />
            <span className="text-label-sm content-base-primary">{currentLanguage.label}</span>
            <ArrowDown2 size={14} color="currentColor" className="shrink-0 content-base-secondary" />
          </button>

          {LANGUAGE_OPTIONS.map((lng) => (
            <DropdownItem key={lng.value} active={i18n.language === lng.value} onClick={() => handleSelect(lng.value)}>
              <img src={lng.flag} alt="" className="w-4 h-4 radius-full object-cover shrink-0" />
              <span>{lng.label}</span>
            </DropdownItem>
          ))}
        </Dropdown>
      </div>
    </div>
  );
}

